
import * as TogglePrimitive from '@radix-ui/react-toggle';
import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@/lib/utils';

const toggleVariants = cva(
  "inline-flex cursor-pointer items-center justify-center gap-2 rounded-md text-[13px] font-medium text-foreground-secondary transition-[background-color,color,box-shadow] duration-200 hover:bg-sunken hover:text-foreground disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-ink data-[state=on]:font-semibold data-[state=on]:text-ink-foreground data-[state=on]:shadow-e1 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0 focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] outline-none transition-[color,box-shadow] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
  {
    variants: {
      variant: {
        default: 'bg-transparent',
        outline:
          'border border-border bg-card',
      },
      size: {
        default: 'h-9 px-3.5 min-w-9',
        sm: 'h-8 px-3 min-w-8',
        lg: 'h-10 px-4 min-w-10',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
);

function Toggle({
  className,
  variant,
  size,
  ...props
}: React.ComponentProps<typeof TogglePrimitive.Root> &
  VariantProps<typeof toggleVariants>) {
  return (
    <TogglePrimitive.Root
      data-slot="toggle"
      className={cn(toggleVariants({ variant, size, className }))}
      {...props}
    />
  );
}

export { Toggle, toggleVariants };
